import { ActionClientStatus } from '../interfaces';

export interface ActionStatusMeta {
  readonly label: string;
  readonly description: string;
  readonly color: string;
  readonly className: string;
}

const FALLBACK_META: ActionStatusMeta = {
  label: '',
  description: '',
  color: '#98a2b3',
  className: 'default',
};

export const ACTION_STATUS_META: ReadonlyMap<ActionClientStatus, ActionStatusMeta> = new Map([
  [
    'TO_PLAN' as ActionClientStatus,
    {
      label: 'To plan',
      description: 'Add all details and request approval from client approver',
      color: '#a6b2bf',
      className: 'to-plan',
    },
  ],
  [
    'PENDING' as ActionClientStatus,
    {
      label: 'Pending',
      description: 'Client approver needs to approve your action request',
      color: '#feba4a',
      className: 'pending',
    },
  ],
  [
    'APPROVED_BY_CLIENT' as ActionClientStatus,
    {
      label: 'Approved by client',
      description: 'Agency needs to approve your action request',
      color: '#00bcd4',
      className: 'approved-by-client',
    },
  ],
  [
    'CONFIRMED' as ActionClientStatus,
    {
      label: 'Confirmed',
      description: 'Agency has approved the action',
      color: '#008dff',
      className: 'confirmed',
    },
  ],
  [
    'ONGOING' as ActionClientStatus,
    {
      label: 'Ongoing',
      description: 'This action is taking place at this moment',
      color: '#000000',
      className: 'in-progress',
    },
  ],
  [
    'IN_PROGRESS' as ActionClientStatus,
    {
      label: 'In progress',
      description: 'This action is being carried out',
      color: '#000000',
      className: 'in-progress',
    },
  ],
  [
    'COMPLETED' as ActionClientStatus,
    {
      label: 'Completed',
      description: 'This action is over, waiting for results',
      color: '#3edd88',
      className: 'completed',
    },
  ],
  [
    'PUBLISHED' as ActionClientStatus,
    {
      label: 'Published',
      description: 'This action is over, the results are published',
      color: '#78909c',
      className: 'published',
    },
  ],
  [
    'CANCELED' as ActionClientStatus,
    {
      label: 'Cancelled',
      description: 'This action has been cancelled',
      color: '#ff7275',
      className: 'cancelled',
    },
  ],
  [
    'CANCELED_BY' as ActionClientStatus,
    {
      label: 'Cancelled',
      description: 'This action has been cancelled',
      color: '#ff7275',
      className: 'cancelled',
    },
  ],
]);

export const ACTION_STATUS_FILTER_ORDER: readonly ActionClientStatus[] = [
  'TO_PLAN',
  'PENDING',
  'APPROVED_BY_CLIENT',
  'CONFIRMED',
  'ONGOING',
  'COMPLETED',
  'PUBLISHED',
  'CANCELED',
];

function metaFor(status: ActionClientStatus | string): ActionStatusMeta {
  return ACTION_STATUS_META.get(status as ActionClientStatus) ?? FALLBACK_META;
}

export function actionStatusLabel(status: ActionClientStatus | string): string {
  return metaFor(status).label || String(status).replace(/_/g, ' ');
}

export function actionStatusDescription(status: ActionClientStatus | string): string {
  return metaFor(status).description;
}

export function actionStatusColor(status: ActionClientStatus | string): string {
  return metaFor(status).color;
}

export function actionStatusClassName(status: ActionClientStatus | string): string {
  return metaFor(status).className;
}
